<template>
  <div class="create-gym">
    <Header />
    <Main>
      <h3 class="text-center">Создание спортзала</h3>
      <b-overlay :show="loading">
        <gym-form v-model="gymData" class="create-gym__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createGym"
        block
        squared
        variant="success"
        class="create-person__create-button"
        :disabled="loading"
      >
        Создать спортзал
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import GymModel from "@/components/Forms/Gym/models/gymModel";
import GymForm from "@/components/Forms/Gym/GymForm";
import BottomOverlay from "@/components/BottomOverlay";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { BottomOverlay, GymForm, Main, Header },
  mixins: [pageTitleMixin],
  data() {
    return {
      gymData: new GymModel(),
      loading: false
    };
  },
  methods: {
    createGym() {
      this.loading = true;
      this.$store
        .dispatch("gyms/createGym", this.gymData)
        .then(() => this.$router.push(`/gyms`))
        .catch(() => (this.loading = false));
    }
  },
  computed: {
    edited: ({ gymData }) =>
      JSON.stringify(gymData) !== JSON.stringify(new GymModel())
  }
};
</script>

<style lang="scss">
.create-gym {
  &__form {
    margin: 0 5px;
  }
}
</style>
